/**
 * Nguồn tải lên mà mẫu đơn cho phép ở một ô upload (`allowed_sources`: 'camera' · 'gallery' · 'file').
 *
 * Cùng luật với kernel `normalizeAllowedSources` (@cnv/server-shared/constants/approvalFields) và app
 * điện thoại (`file_upload_field.dart` `_effectiveSources`): bỏ giá trị lạ / trùng; ô CHỈ ẢNH (image,
 * out_evidence) không nhận 'file'; chưa cấu hình hoặc lọc xong rỗng ⇒ mặc định theo loại ô.
 *
 * Trước 01/10/2026 web bỏ qua hẳn khoá này: mẫu «chỉ Chụp ảnh» (mặc định của ô Minh chứng đơn Xin ra
 * ngoài) trên app mở thẳng camera, còn trên web vẫn mở hộp chọn tệp — chọn ảnh có sẵn thoải mái.
 *
 * Tệp thuần (không JSX, không import) để soát được bằng node trần.
 */
export const UPLOAD_SOURCES = Object.freeze(['camera', 'gallery', 'file']);

export function uploadSourcesOf(field, imageOnly) {
  const fallback = imageOnly ? ['camera', 'gallery'] : ['camera', 'gallery', 'file'];
  // Builder ghi ở gốc field; app còn đọc cả `config.allowed_sources` (mẫu cũ) — giữ cùng thứ tự đó.
  const raw = Array.isArray(field?.allowed_sources) ? field.allowed_sources
    : (Array.isArray(field?.config?.allowed_sources) ? field.config.allowed_sources : null);
  if (!raw || raw.length === 0) return fallback;
  const out = [];
  for (const v of raw) {
    if (typeof v !== 'string') continue;
    const s = v.toLowerCase().trim();
    if (!UPLOAD_SOURCES.includes(s) || out.includes(s)) continue;
    if (imageOnly && s === 'file') continue;
    out.push(s);
  }
  return out.length ? out : fallback;
}

/** «Chỉ chụp ảnh» = không còn nguồn nào chọn tệp có sẵn (thư viện / tệp khác). */
export function isCameraOnly(sources) {
  return Array.isArray(sources) && !sources.includes('gallery') && !sources.includes('file');
}
